import React ,{useEffect, useState} from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,CardHeader,
  Paper,Checkbox,IconButton,Button,Box,Popover,TextField,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import {  Print } from "@mui/icons-material";
import { handlePrint } from "../Purchase_order/PurchaseOrderPrint";

import "react-toastify/dist/ReactToastify.css";
import {GetPurchaseVoucherList, fetchpos,
  ApprovePO, PurchaseDashboardCounts} from "../../../Services/Services";
// === Card Icons ===
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import StoreIcon from "@mui/icons-material/Store";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import InventoryIcon from "@mui/icons-material/Inventory";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BarChartIcon from "@mui/icons-material/BarChart";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { data } from "react-router";

// ==== Card Colors (Purchase Dashboard specific) ====
const cardColors = [
  "#7ed321", // Purchase Vouchers - light green
  "#c4b5f6", // Payments - Lavender Blue
  "#3498db", // General Vouchers - light blue
  "#2ecc71", // Reports - green
  "#e74c3c", // Approved Transactions - red
  "#f39c12", // Pending Approvals - orange
  "#9b59b6", // Purchase Dashboard - purple
  "#34495e", // Audit Logs - dark blue
];

// ==== Card Data for Purchase Dashboard ====


export default function PurchaseDashboard() {
  const[counts, setCounts] = useState({});
  const [stats, setStats] = useState([]);
  const [po, setpos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [suppliers, setSuppliers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [voucherList, setVoucherList] = useState([]);
  const [approveAnchorEl, setApproveAnchorEl] = useState(null);
  const [poToApprove, setPoToApprove] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(null);
  const [showRemarkForPoId, setShowRemarkForPoId] = useState(null);
  useEffect(() => {
     fetchVouchers();
     fetchData();
  }, []);
    const fetchVouchers = async () => {
      try {
        const data = await GetPurchaseVoucherList();
        setVoucherList(data);
      } catch (error) {
        console.error("Error fetching vouchers:", error);
      }
    };

useEffect(() => {
    const loadPo = async () => {
      try {
        const data = await fetchpos();
        setProjects(data);
      } catch (error) {
        setError("Failed to load data");
      } finally {
        setLoading(false);
      }
    };
    loadPo();}, []);


      const handleApprove = async (po) => {
        const approvedById = Number(localStorage.getItem("user_id"));
        if (!approvedById) {
          toast.error("Approver ID not found.");
          return;
        }
        try {
          const updated = await ApprovePO(
            po.id,
            approvedById,
            po.approval_status,
            remarkInput
          ); // ✅ FIXED
          setpos((prev) =>
            prev.map((item) => (item.id === po.id ? updated : item))
          );
          const UpdtedList = await fetchpos();
          setProjects(UpdtedList);
          toast.success(
            updated.approval_status
              ? "PO approved successfully!"
              : "PO unapproved successfully!"
          );
        } catch (error) {
          console.error("Approval Error:", error);
          toast.error("Failed to approve PO.");
        }
      };
    const userRole = localStorage.getItem("role");

    const fetchData = async () => {
  const data=await PurchaseDashboardCounts();
  setCounts(data);

setStats ([
  { title: "Total Purchase ",
    value:data.total_po, 
    icon: <ShoppingCartIcon fontSize="large" /> },
  { title: "Approved Purchase",
    value:data.approved_po,  icon: <CheckCircleIcon fontSize="large" /> },
  { title: "Pending Purchase", 
    value:data.pending_po, icon: <ThumbUpIcon fontSize="large" /> },
  { title: "Today Purchase ", 
    value:data.today_po, icon: <StoreIcon fontSize="large" /> },
].map((stat, i) => ({
    ...stat,
    bgColor: cardColors[i % cardColors.length],
  })));
};


  const filteredProjects = projects.filter((po) => {
  

    // ✅ Case-insensitive check
    const statusMatch = po.approval_status?.toLowerCase() === "pending";

    return (
statusMatch
    );
  });

  return (
    <div style={{ padding: "20px" }}>
      {/* ==== CARDS ==== */}
      <Grid container spacing={2} sx={{ mt: -3, mb: 2 }}>
        {stats.map((card, index) => (
          <Grid item xs={12} sm={6} md={3} key={index} sx={{ mt: -4, mb: 4 }}>
            <Card
              sx={{
                height: 100,
                borderRadius: 0,
                background: cardColors[index],
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                p: 2,

                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "translateY(-5px)",

                },
              }}
            >
              <div style={{ marginRight: 12 }}>{card.icon}</div>
              <CardContent sx={{ p: 0 }}>
                <Typography variant="subtitle1" fontWeight="bold">
                  {card.title}
                </Typography>
                <Typography variant="caption" display="block">
                  {card.value}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* ==== Pending Purchase Table ==== */}
        <Card sx={{ boxShadow: 3, mt: 2 }}>
        <CardHeader
                stickyHeader
                title="Pending PO"
                titleTypographyProps={{
                  variant: "h6",
                  fontWeight: "bold",
                  color: "black",
                }}
                sx={{ pb: 0 }}
              />
      
              <CardContent>
              
      <TableContainer
                component={Paper}
                sx={{ overflow: "auto", maxHeight: "80vh" }}
              >
                <Table
                  stickyHeader
                  size="small"
                  sx={{
                    minWidth: "max-content",
                    "& td, & th": {
                      borderBottom: "1px solid #ccc",
                      whiteSpace: "nowrap",
                    },
                  }}
                >
                  <TableHead
                    sx={{
                      "& th": {
                        fontWeight: "bold",
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "#2196f3" : "#333",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                      },
                    }}
                  >
                    <TableRow
                      sx={{
                        backgroundColor: "#f5f5f5",
                        "& th": {
                          fontWeight: "bold",
                          color: "#333",
                          borderBottom: "1px solid #999",
                          whiteSpace: "nowrap",
                        },
                      }}
                    >
                      {userRole != "Staff" && (
                        <TableCell
                          sx={{
                            position: "sticky",
                            left: 0,
                            backgroundColor: "#f5f5f5",
                            zIndex: 3,
                            minWidth: 80,
                          }}
                          align="center"
                        >
                          Approve
                        </TableCell>
                      )}
    
                      <TableCell
                        sx={{
                          position: "sticky",
                          left: userRole != "Staff" ? 80 : 0, // ← exactly after Approve (80px)
                          backgroundColor: "#f5f5f5",
                          zIndex: 3,
                          minWidth: 80,
                        }}
                        align="center"
                      >
                        S.No.
                      </TableCell>
                      <TableCell
                        sx={{
                          position: "sticky",
                          left: userRole != "Staff" ? 160 : 80, // ← Approve (80) + S.No. (80)
                          backgroundColor: "#f5f5f5",
                          zIndex: 3,
                          minWidth: 120,
                        }}
                        align="center"
                      >
                        PO Number
                      </TableCell>
    
                      <TableCell align="center">Supplier</TableCell>
                      <TableCell align="center">Billing Address</TableCell>
                      <TableCell align="center">Shipping Address</TableCell>
                      <TableCell align="center">Created At</TableCell>
                      <TableCell align="center">Created By</TableCell>
                      <TableCell align="center">Approved By</TableCell>
                      <TableCell align="center">Status</TableCell>
                      <TableCell align="center">Remarks</TableCell>
                      <TableCell
                        sx={{
                          position: "sticky",
                          right: 0,
                          backgroundColor: "#fff",
                          zIndex: 3,
                        }}
                        align="center"
                      >
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredProjects.map((po, index) => (
                      <React.Fragment key={po.id}>
                        <TableRow
                          hover
                          key={index}
                          sx={{
                            position: "sticky",
                            right: 0,
                            backgroundColor: "#fff",
                            zIndex: 1,
    
                            backgroundColor:
                              index % 2 === 0 ? "#fafafa" : "#ffffff", // alternate row color
                            "&:hover": {
                              backgroundColor: "#e3f2fd",
                              "& td": {
                                backgroundColor: "#e3f2fd !important",
                              },
                            },
                            "& td": {
                              paddingTop: "2px !important",
                              paddingBottom: "2px !important",
                              fontSize: { xs: "0.75rem", sm: "0.8125rem" }, // responsive font
                              whiteSpace: "nowrap",
                              color: (theme) =>
                                theme.palette.mode === "dark" ? "white" : "inherit",
                              backgroundColor: (theme) =>
                                theme.palette.mode === "dark" ? "black" : "inherit",
                            },
                          }}
                        >
                          {userRole != "Staff" && (
                            <TableCell
                              sx={{
                                position: "sticky",
                                left: 0,
                                backgroundColor: "#fafafa",
                                zIndex: 2,
                                minWidth: 80,
                              }}
                              align="center"
                            >
                              <Checkbox
                                checked={
                                  po.approval_status === "Approved" ||
                                  po.approval_status === "Rejected"
                                }
                                onChange={(e) => {
                                  setApproveAnchorEl(e.currentTarget);
                                  setPoToApprove(po);
                                }}
                                sx={{
                                  padding: 0,
                                  paddingLeft: 1,
                                  paddingRight: 1,
                                  transform: "scale(0.8)", // 👈 size kam kar diya
    
                                  color:
                                    po.approval_status === "Approved"
                                      ? "green"
                                      : po.approval_status === "Rejected"
                                      ? "red"
                                      : "grey",
                                  "&.Mui-checked": {
                                    color:
                                      po.approval_status === "Approved"
                                        ? "green"
                                        : "red",
                                  },
                                }}
                              />
                            </TableCell>
                          )}
    
                          <TableCell
                            sx={{
                              position: "sticky",
                              left: userRole != "Staff" ? 80 : 0,
                              backgroundColor: "#fafafa",
                              zIndex: 2,
                              minWidth: 80,
                            }}
                            align="center"
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            sx={{
                              position: "sticky",
                              left: userRole != "Staff" ? 160 : 80,
                              backgroundColor: "#fafafa",
                              zIndex: 2,
                              minWidth: 120,
                            }}
                            align="center"
                          >
                            {po.po_number}
                          </TableCell>
    
                          {/* ✅ Properly mapped Supplier Name */}
                          <TableCell align="center">
                            {po.supplier_name ? po.supplier_name : "N/A"}
                          </TableCell>
    
                          <TableCell align="center">{po.billing_address}</TableCell>
                          <TableCell align="center">
                            {po.shipping_address}
                          </TableCell>
                          <TableCell align="center">
                            {new Date(po.created_at).toLocaleDateString()}
                          </TableCell>
                          <TableCell align="center">
                            {po.created_by_name ? po.created_by_name : "N/A"}
                          </TableCell>
                          <TableCell align="center">
                            {po.approved_name ? po.approved_name : ""}
                          </TableCell>
                          <TableCell align="center">{po.approval_status}</TableCell>
                          <TableCell align="center">{po.remarks || ""}</TableCell>
                          <TableCell
                            sx={{
                              position: "sticky",
                              right: 0,
                              zIndex: 3,
                            }}
                            align="center"
                          >
                            <IconButton
                              sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                              size="small"
                              color="primary"
                              onClick={() => handlePrint(po)}
                            >
                              <Print fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              </CardContent>
             </Card>
              
                    <Popover
                      open={Boolean(approveAnchorEl)}
                      anchorEl={approveAnchorEl}
                      onClose={() => {
                        setApproveAnchorEl(null);
                        setPoToApprove(null);
                        setRemarkInput("");
                        setShowRemarkForPoId(null);
                        setActionType(null);
                      }}
                      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                      transformOrigin={{ vertical: "top", horizontal: "center" }}
                    >
                      <Box sx={{ p: 2, minWidth: 250 }}>
                        {/* Step 1: Reject clicked → show remark input */}
                        {showRemarkForPoId === poToApprove?.id ? (
                          <>
                            <Typography variant="body2" sx={{ mb: 1 }}>
                              Please enter remark before{" "}
                              {actionType === "Approved" ? "approving" : "rejecting"}:
                            </Typography>
                            <TextField
                              fullWidth
                              size="small"
                              value={remarkInput}
                              onChange={(e) => setRemarkInput(e.target.value)}
                              placeholder="Enter remark"
                            />
              
                            {/* Yes/No buttons */}
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                mt: 2,
                              }}
                            >
                              <Button
                                color={actionType === "Approved" ? "success" : "error"}
                                size="small"
                                onClick={() => {
                                  if (!remarkInput.trim()) {
                                    toast.error("Remark is required!");
                                    return;
                                  }
                                  // ✅ Reject with remark
                                  handleApprove({
                                    ...poToApprove,
                                    approval_status: actionType,
                                    remarks: remarkInput,
                                  });
                                  setApproveAnchorEl(null);
                                  setPoToApprove(null);
                                  setRemarkInput("");
                                  setShowRemarkForPoId(null);
                                  setActionType(null);
                                }}
                              >
                                Yes
                              </Button>
                              <Button
                                size="small"
                                onClick={() => {
                                  setApproveAnchorEl(null);
                                  setPoToApprove(null);
                                  setRemarkInput("");
                                  setShowRemarkForPoId(null);
                                  setActionType(null);
                                }}
                              >
                                No
                              </Button>
                            </Box>
                          </>
                        ) : (
                          <>
                            <Typography variant="body2" sx={{ mb: 1 }}>
                              Do you want to approve or reject this indent?
                            </Typography>
              
                            {/* Approve/Reject buttons */}
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                mt: 2,
                              }}
                            >
                              <Button
                                color="success"
                                size="small"
                                onClick={() => {
                                  setShowRemarkForPoId(poToApprove?.id);
                                  setActionType("Approved");
                                }}
                              >
                                Approve
                              </Button>
                              <Button
                                color="error"
                                size="small"
                                onClick={() => {
                                  // ✅ Switch to remark input mode
                                  setShowRemarkForPoId(poToApprove?.id);
                                  setActionType("Rejected");
                                }}
                              >
                                Reject
                              </Button>
                            </Box>
                          </>
                        )}
                      </Box>
                    </Popover>
    </div>
  );
}
